import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PDF_URL = "/guia-dron-vs-aplicacion-terrestre.pdf";

const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
};

const Guia = () => {
  const [whatsapp, setWhatsapp] = useState("");
  const [loading, setLoading] = useState(false);

  const download = async () => {
    setLoading(true);
    try {
      if (whatsapp.trim()) {
        await axios.post(`${API}/leads`, { whatsapp: whatsapp.trim() });
        toast.success("Listo. Te avisamos cuando salga la próxima guía.");
      }
    } catch {
    } finally {
      window.open(PDF_URL, "_blank", "noopener,noreferrer");
      setLoading(false);
    }
  };

  return (
    <section id="guia" data-testid="guia-section" className="bg-[#F6F7F5] text-[#151A1F] py-24 sm:py-32 border-t border-[#151A1F]/10">
      <div className="mx-auto max-w-7xl px-6 sm:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <motion.p {...reveal} className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#046A38]">
              Guía gratuita · PDF
            </motion.p>
            <motion.h2
              {...reveal}
              transition={{ ...reveal.transition, delay: 0.1 }}
              className="font-display font-bold tracking-tight leading-[1.08] text-2xl sm:text-4xl lg:text-5xl mt-6"
            >
              Dron vs Aplicación Terrestre: la guía para decidir con números.
            </motion.h2>
            <motion.p
              {...reveal}
              transition={{ ...reveal.transition, delay: 0.15 }}
              className="mt-6 max-w-xl text-base sm:text-lg text-[#151A1F]/70 leading-relaxed"
            >
              Agua por hectárea, pisoteo, velocidad y un ejemplo de retorno con 500 ha de soya.
              Descargala gratis, comprobá el retorno de inversión con tus propios números y
              después hablamos.
            </motion.p>
            <motion.div
              {...reveal}
              transition={{ ...reveal.transition, delay: 0.2 }}
              className="mt-10 flex flex-col sm:flex-row gap-4 max-w-xl"
            >
              <input
                data-testid="guia-whatsapp-input"
                type="tel"
                value={whatsapp}
                onChange={(e) => setWhatsapp(e.target.value)}
                placeholder="Tu WhatsApp (opcional, para la próxima guía)"
                className="flex-1 bg-white border border-[#151A1F]/15 rounded-sm px-4 py-4 text-base text-[#151A1F] placeholder:text-[#151A1F]/35 focus:outline-none focus:border-[#046A38] transition-colors tabular"
              />
              <button
                data-testid="guia-download-button"
                onClick={download}
                disabled={loading}
                className="inline-flex items-center justify-center gap-3 bg-[#151A1F] text-[#F6F7F5] font-display font-semibold text-base px-8 py-4 rounded-full hover:bg-[#046A38] transition-colors duration-300 disabled:opacity-60"
              >
                {loading ? <Loader2 size={18} className="animate-spin" /> : <FileDown size={18} />}
                Descargar guía gratis
              </button>
            </motion.div>
            <motion.p
              {...reveal}
              transition={{ ...reveal.transition, delay: 0.25 }}
              className="mt-4 font-mono-tech text-[10px] uppercase tracking-[0.2em] text-[#6B7280]"
            >
              Sin spam · Sin compromiso · El PDF se abre directo
            </motion.p>
          </div>

          <motion.div {...reveal} transition={{ ...reveal.transition, delay: 0.2 }} className="lg:col-span-5">
            <div className="relative bg-[#151A1F] rounded-sm p-10 sm:p-12 overflow-hidden">
              <div className="absolute inset-0 hairlines" aria-hidden="true" />
              <div className="relative">
                <p className="font-wordmark font-bold text-2xl text-[#F6F7F5]">
                  FUMI<span className="text-[#00A651]">G</span><span className="text-[#00A651]">A</span>
                </p>
                <p className="font-display font-bold text-3xl sm:text-4xl text-[#F6F7F5] tracking-tight mt-10 leading-tight">
                  Dron vs Aplicación Terrestre
                </p>
                <p className="mt-4 text-[#00A651] font-display font-semibold">La guía comparativa para decidir con números</p>
                <div className="mt-10 flex items-center justify-between">
                  <p className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[#F6F7F5]/45">
                    5 páginas · Tabla + ROI · 2026
                  </p>
                  <FileDown size={22} className="text-[#FFB000]" />
                </div>
              </div>
              <div className="absolute -bottom-px -right-px w-10 h-10 border-b-2 border-r-2 border-[#00A651]" aria-hidden="true" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Guia;
